import { useContext } from "react";
import { CurrentExerciseContext } from "src/providers/CurrentExerciseProvider";
import { ItemList } from "src/components/presentational/ItemList";
import { findAndExecute } from "src/commons/purefunctions/findAndExecute";
import { TextContext } from "src/providers/TextProvider";
import { VIMTUTOR_SECTIONS } from "src/sources/generators/vimtutor-exercises.generator";

const ExerciseSidebarContainer = () => {
  const { setCurrent } = useContext(CurrentExerciseContext);
  const { setText } = useContext(TextContext);

  return (
    <div className="exercise-sidebar">
      <h2>Exercises</h2>
      {VIMTUTOR_SECTIONS.map((section, index) => (
        <ItemList
          key={index}
          id={index}
          title={section.title}
          items={section.exercises}
          onItemClick={(id) =>
            findAndExecute(section.exercises, id, (exercise) => {
              setCurrent(exercise);
              setText(exercise.initialState);
            })
          }
        />
      ))}
    </div>
  );
};

export { ExerciseSidebarContainer };
